import { req } from "@/api/api_request";

// 报警类型列表
export function getAlarmTypeList() {
  let url = `alarm/get-alarm-type-list`;
  return req.get(url);
}

// 获取报警配置列表
export function getAlarmList(group_id, page, size) {
  let url = `alarm/get-list?group_id=${group_id}&page=${page}&size=${size}`;
  return req.get(url);
}

// 添加报警配置
export function addAlarmRule(params) {
  let url = `alarm/add`;
  return req.post(url, params);
}

// 更新报警配置
export function updateAlarmRule(params) {
  let url = `alarm/update`;
  return req.post(url, params);
}

// 删除报警配置
export function deleteAlarmRule(user_id) {
  let url = `alarm/delete?alarm_id=${user_id}`;
  return req.post(url);
}

// 获取报警日志列表
export function getAlarmLogList(params) {
  let url = `alarm/get-log-list?group_id=${params.group_id}&alarm_start_time=${params.alarm_start_time}&alarm_end_time=${params.alarm_end_time}`;
  if (params.page) {
    url += `&page=${params.page}`;
  }
  if (params.size) {
    url += `&size=${params.size}`;
  }
  if (params.station_name) {
    url += `&station_name=${params.station_name}`;
  }
  if (params.alarm_type) {
    url += `&alarm_type=${params.alarm_type}`;
  }
  if (params.alarm_status == 0 || params.alarm_status == 1) {
    url += `&alarm_status=${params.alarm_status}`;
  }
  return req.get(url);
}
